export default __webpack_public_path__ + "static/media/footer.84ca579c.svg";